import { createReducer, on } from '@ngrx/store';

import {
    agreeLegals,
    agreeLegalsClear,
    errorGetLegalVersion,
    errorUpdateLegalVersion,
    errroAgreeLegals,
    errroGetLegals,
    getLegals,
    GetLegalsClear,
    getLegalVersion,
    getLegalVersionClear,
    successAgreeLegals,
    successGetLegals,
    successGetLegalVersion,
    successUpdateLegalVersion,
    updateLegalVersion,
} from '../actions/legals.actions';
import { ILegacyDocument, ILegalVersion } from './../../shared/models/Legales';

/**
 * * Acepta los legales
 */
export interface LegalAgreeState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: string;
}

export const LegalAgreeInit: LegalAgreeState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: '',
};

const _legalsAgreeReducer = createReducer(
    LegalAgreeInit,
    on(agreeLegals, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successAgreeLegals, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errroAgreeLegals, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(agreeLegalsClear, state => ({ ...state, ...LegalAgreeInit }))
);

export function LegalAgreeReducer(state: any, action: any) {
    return _legalsAgreeReducer(state, action);
}


/**
 * * Consulta los legales
 */
export interface LegalGetState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ILegacyDocument;
}

export const LegalGetInit: LegalGetState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as ILegacyDocument,
};

const _legalsGetReducer = createReducer(
    LegalGetInit,
    on(getLegals, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetLegals, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errroGetLegals, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    )),
    on(GetLegalsClear, state => ({ ...state, ...LegalGetInit }))
);

export function LegalGetReducer(state: any, action: any) {
    return _legalsGetReducer(state, action);
}

/**
 * * Obtiene versión legal por ID
 */
export interface LegalVersionState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: ILegalVersion[];
}

export const LegalVersionInit: LegalVersionState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: [],
};

export interface LegalStates {
    LegalVersionGet: LegalVersionState;
    LegalVersionUpdate: LegalVersionState;
}

export const LegalInit: LegalStates = {
    LegalVersionGet: LegalVersionInit,
    LegalVersionUpdate: LegalVersionInit,
};

const _legalVersionReducer = createReducer(
    LegalInit,
    on(getLegalVersion, state => (
        {
            ...state,
            LegalVersionGet: {
                ...state.LegalVersionGet,
                loading: true,
                success: false,
                failed: false,
            }
        }
    )),
    on(successGetLegalVersion, (state, { data }) => (
        {
            ...state,
            LegalVersionGet: {
                ...state.LegalVersionGet,
                loading: false,
                success: true,
                data: data.map(l => ({
                    ID_LegalTipo: l.idLegaltipo,
                    TipoLegal: l.tipoLegal,
                    Version: l.version,
                    Documento: l.documento,
                    Aceptado: l.aceptado,
                })),
            }
        }
    )),
    on(errorGetLegalVersion, (state, { payload }) => (
        {
            ...state,
            LegalVersionGet: {
                ...state.LegalVersionGet,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
    on(getLegalVersionClear, state => ({ ...state, ...LegalInit })),
    /**
     * * Actualiza versión legal
     */
    on(updateLegalVersion, state => (
        {
            ...state,
            LegalVersionUpdate: {
                ...state.LegalVersionUpdate,
                loading: true,
                success: false,
                failed: false,
            }
        }
    )),
    on(successUpdateLegalVersion, (state, { data }) => (
        {
            ...state,
            LegalVersionUpdate: {
                ...state.LegalVersionUpdate,
                loading: false,
                success: true,
            },
            LegalVersionGet: {
                ...state.LegalVersionGet,
                data: state.LegalVersionGet.data.map(l => {
                    const legal = data.filter(d => d.idLegaltipo === l.ID_LegalTipo && d.version === l.Version);
                    return {
                        ...l,
                        Aceptado: legal.length > 0 ? legal[0].aceptado : l.Aceptado,
                    };
                }),
            }
        }
    )),
    on(errorUpdateLegalVersion, (state, { payload }) => (
        {
            ...state,
            LegalVersionUpdate: {
                ...state.LegalVersionUpdate,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
);

export function LegalVersionReducer(state: any, action: any) {
    return _legalVersionReducer(state, action);
}
